import { Injectable, Inject } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Auth0Service } from '../services/auth0.service';

@Injectable({
  providedIn: 'root'
})
export class Auth0Guard implements CanActivate {

  constructor(@Inject(Auth0Service) private auth0Service: Auth0Service) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    
    return this.auth0Service.isAuthenticated$().pipe(
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          // Determine if this is a global route
          const isGlobalRoute = state.url.startsWith('/Global') || state.url.startsWith('/GlobalAdmin');
          
          // Trigger appropriate login
          if (isGlobalRoute) {
            this.auth0Service.loginGlobal(state.url);
          } else {
            this.auth0Service.loginRegular(state.url);
          }
        }
      }),
      map(isAuthenticated => isAuthenticated)
    );
  }
}
